import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CustomerT } from '../../types';
import { GetCustomer, getInvoiceStats, getPaymentReminder } from '../../backend-services';
import toast from 'react-hot-toast';
import {CustomerDetails} from "../../components/customers/view/customerDetail";
import {IInvoice, InvoiceStatsData} from "../../@types";
import PageLoader from "../../components/common/PageLoader";
import { SidebarDrawer } from '../../components/common';
import { CustomerDeletePrompt } from '../../components/customers/CustomerDelete';
import { SendReminderPrompt } from '../../components/invoice/SendReminderPrompt';
import LeftNotificationPopup from '../../components/core/NotificationPopup/LeftNotificationPopup';
import ProcessSuccessful from '../../assets/icons/ProcessSuccessful';

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  address: '',
  city: '',
  state: '',
};

export const ViewCustomers = () => {
  const { customerId } = useParams();
  if (!customerId) throw new Error('Invoice Id is missing');

  const [customer, setCustomer] = useState<CustomerT>(initialState);
  const [isLoading, setIsLoading] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);
  const [DrawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [data, setData] = useState<InvoiceStatsData>();
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [paymentReminder, setPaymentReminder] = useState(null);
  const [isReminderSent, setIsReminderSent] = React.useState(false);
  const [invoice, setInvoice] = useState<IInvoice>();

  useEffect(() => {
    fetchInvoiceStats();
    getCustomerHandler();
  }, [customerId]);

  useEffect(() => {
console.log(customer)
  }, [customer]);
  const fetchInvoiceStats = async () => {
    const currentTime = new Date().toISOString();
    const response = await getInvoiceStats(currentTime, currentTime);
    setData(response);
  };

  const getCustomerHandler = async () => {
    setIsLoading(true);
    try {
      const data = await GetCustomer(customerId);
      console.log(data)
      setCustomer(data);
    } catch (e) {
      toast.error('Failed to fetch customer invoices');
    } finally {
      setIsLoading(false);
    }
  };

  const toggleDrawer = () => {
    setDrawerOpen(prevState => !prevState);
  };
  const handleCustomerDeleteSuccess = () => {
    setShowSuccessModal(true);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const PaymentReminder = async () => {
    try {
      if (customerId) {
        const reminder = await getPaymentReminder(customerId);
        setPaymentReminder(reminder);
        setIsReminderSent(true);
      }
    } catch (error) {
      toast.error('Failed to send payment reminder.');
    }
  };
 
  return (
    <>
      {isLoading ? (
        <PageLoader/>
      ) : (
        <div>
          {showPrompt && (
              <>
            <SidebarDrawer title={'Delete Expense'} show={true} position={'left'} onClose={() => setShowPrompt(false)}>
              <CustomerDeletePrompt showPrompt={showPrompt} show={() => setShowPrompt(false)} customerId={customerId} onClose={() => setShowPrompt(false)} onDeleteSuccess={handleCustomerDeleteSuccess}/>
             </SidebarDrawer>
             </>
            )}
             {isSidebarOpen && (
        <SidebarDrawer title={'Send Reminder'} show={true} position={'left'}>
          <SendReminderPrompt
           onSend={PaymentReminder} 
           onClose={() => setIsSidebarOpen(false)} 
           isSidebarOpen={isSidebarOpen} 
           invoice={invoice} 
           customerId={customerId}  
           //@ts-ignore
           customerEmail={customer.email}
          />
        </SidebarDrawer>
      )}
      {isReminderSent && (
        <SidebarDrawer title={''} show={true} position={'left'}>
          <LeftNotificationPopup title={'You sent a payment reminder'} icon={<ProcessSuccessful />} />
        </SidebarDrawer>
      )}
          <div className="lg:flex lg:items-center lg:gap-[8.5px] xl:ml-[-1em] ml-[-2em] md:ml-[0.2em] lg:ml-[]">
          <a href="/customers">
            <svg
              className="mt-[4px]"
              width="10"
              height="16"
              viewBox="0 0 10 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8.5 1L1.5 8L8.5 15" stroke="#33363F" strokeWidth="2" />
            </svg>
          </a>
          <h1 className="flex items-center text-[20px] font-bold ml-[1em] mt-[-1.2em] md:mt-[-1.2em] lg:mt-[0.1em] xl:mt-[-0.2em]">customers</h1>
        </div>
        <CustomerDetails
              customer={customer}
              data={data}
              DrawerOpen={DrawerOpen}
              showIsLoading={() => setIsLoading(true)}
              hideIsLoading={() => setIsLoading(false)}
              showPrompt={showPrompt}
              toggleDrawer={toggleDrawer}
              setShowPrompt={setShowPrompt}
              setIsSidebarOpen={setIsSidebarOpen} 
                    />
        </div>
      )}
    </>
  );
};
